import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackClarityEvent } from "../utils/ClarityAnalytics";
import { trackEvent } from "../utils/firebaseEvents";
import { CLARITY_EVENTS } from "../utils/EventTypes";

export const useClarityPageView = () => {
  const location = useLocation();

  useEffect(() => {
    const payload = { path: location.pathname };

    trackClarityEvent(CLARITY_EVENTS.PAGE_VIEW, payload);
    trackEvent(CLARITY_EVENTS.PAGE_VIEW, payload);
  }, [location.pathname]);
};